document.addEventListener("DOMContentLoaded", () => {
    const slides = document.querySelectorAll(".slider .slide");
    if (slides.length === 0) {
        return;
    }

    const OPEN_CLASS = 'slide_open';

    const updateSlideState = (slide) => {
        const slideName = slide.querySelector(".slide__name");
        if (slideName) {
            slideName.setAttribute("aria-expanded", slide.classList.contains(OPEN_CLASS) ? "true" : "false");
        }
    };

    // Убедимся, что первый слайд всегда открыт
    if (slides.length > 0) {
        slides.forEach((slide, index) => {
            if (index === 0) {
                slide.classList.add(OPEN_CLASS);
            }
            updateSlideState(slide);
        });

        if (document.location.hash.length > 0) {
            const searchID = document.location.hash.replace('#', '');
            const target = document.getElementById(searchID);

            if (target) {
                const targetSlide = target.closest('.slide');
                if (targetSlide) {
                    targetSlide.classList.add(OPEN_CLASS);
                    updateSlideState(targetSlide);
                } else if (target.classList.contains('slide')) {
                    target.classList.add(OPEN_CLASS);
                    updateSlideState(target);
                }
            }
        }
    }

    // Добавляем обработчик событий на каждую кнопку или элемент для переключения слайда
    slides.forEach((slide) => {
        const slideName = slide.querySelector(".slide__name");
        if (slideName) {
            slideName.setAttribute("tabindex", "0");
            slideName.setAttribute("role", "button");
            updateSlideState(slide);

            const toggleSlide = () => {
                // Закрываем все слайды
                // slides.forEach((s) => s.classList.remove(OPEN_CLASS));

                if (slide.classList.contains(OPEN_CLASS)) {
                    slide.classList.remove(OPEN_CLASS)
                    updateSlideState(slide);
                    return
                }

                // Открываем текущий слайд
                slide.classList.add(OPEN_CLASS);
                updateSlideState(slide);
            };

            slideName.addEventListener("click", toggleSlide);
            slideName.addEventListener("keydown", (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggleSlide();
                }
            });
        }
    });
});
